import { render, staticRenderFns } from "./CardAdvanceCongratulation.vue?vue&type=template&id=45dfea5e&"
import script from "./CardAdvanceCongratulation.vue?vue&type=script&lang=js&"
export * from "./CardAdvanceCongratulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports